// extracted by mini-css-extract-plugin
module.exports = {"img":"image_img__1SpIU","notSelected":"image_notSelected__w3O3d"};